import React, { useState } from "react";
import { useTrades, useCapital } from "../useJournal";

const fmt = (n,pre="₹") => { if(n==null||isNaN(n))return"—"; return pre+Number(n).toLocaleString("en-IN",{minimumFractionDigits:2,maximumFractionDigits:2}); };

export default function PositionManager() {
  const { trades, updateTrade } = useTrades();
  const { totalCapital } = useCapital();
  const [revisedSL, setRevisedSL] = useState({});

  const openTrades = trades.filter(t=>t.status==="open");
  const totalInitialTOR = openTrades.reduce((s,t)=>{ const exitedQty=(t.exits||[]).reduce((q,e)=>q+e.exit_quantity,0); return s+(t.entry_price-t.initial_sl)*(t.quantity-exitedQty); },0);
  const totalDeployed = openTrades.reduce((s,t)=>s+t.entry_price*t.quantity,0);
  const torPct = totalCapital>0?(totalInitialTOR/totalCapital)*100:0;
  const torWarning = torPct>=5;
  const torBlocked = torPct>=6;

  return (
    <div style={{maxWidth:1100,margin:"0 auto"}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:20}}>
        <div style={{background:"white",border:"1px solid #e5e7eb",borderRadius:8,padding:16}}>
          <div style={{fontSize:11,color:"#6b7280",fontWeight:600,textTransform:"uppercase",marginBottom:6}}>Capital Deployed</div>
          <div style={{fontSize:20,fontWeight:800,fontFamily:"monospace"}}>{fmt(totalCapital)}</div>
        </div>
        <div style={{background:"white",border:"1px solid #e5e7eb",borderRadius:8,padding:16}}>
          <div style={{fontSize:11,color:"#6b7280",fontWeight:600,textTransform:"uppercase",marginBottom:6}}>Open Exposure</div>
          <div style={{fontSize:20,fontWeight:800,fontFamily:"monospace"}}>{fmt(totalDeployed)}</div>
          <div style={{fontSize:11,color:"#9ca3af"}}>{totalCapital>0?((totalDeployed/totalCapital)*100).toFixed(1):0}% of capital</div>
        </div>
        <div style={{background:torBlocked?"#fef2f2":torWarning?"#fff7ed":"white",border:`1px solid ${torBlocked?"#fecaca":torWarning?"#fed7aa":"#e5e7eb"}`,borderRadius:8,padding:16}}>
          <div style={{fontSize:11,color:"#6b7280",fontWeight:600,textTransform:"uppercase",marginBottom:6}}>Portfolio TOR</div>
          <div style={{fontSize:20,fontWeight:800,fontFamily:"monospace",color:torBlocked?"#dc2626":torWarning?"#ea580c":"#111827"}}>{fmt(totalInitialTOR)}</div>
          <div style={{fontSize:11,color:torBlocked?"#dc2626":torWarning?"#ea580c":"#9ca3af",fontWeight:600}}>{torPct.toFixed(2)}% {torBlocked?"⛔ BLOCKED":torWarning?"⚠️ Warning":"(max 6%)"}</div>
        </div>
        <div style={{background:"white",border:"1px solid #e5e7eb",borderRadius:8,padding:16}}>
          <div style={{fontSize:11,color:"#6b7280",fontWeight:600,textTransform:"uppercase",marginBottom:6}}>Open Positions</div>
          <div style={{fontSize:20,fontWeight:800,fontFamily:"monospace"}}>{openTrades.length}</div>
        </div>
      </div>

      <div style={{background:"white",border:"1px solid #e5e7eb",borderRadius:8,overflow:"hidden"}}>
        <div style={{padding:"12px 16px",borderBottom:"1px solid #e5e7eb",fontWeight:700}}>Open Positions ({openTrades.length})</div>
        {openTrades.length===0 ? (
          <div style={{padding:40,textAlign:"center",color:"#9ca3af"}}>No open positions</div>
        ) : (
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
            <thead><tr style={{background:"#f9fafb",borderBottom:"1px solid #e5e7eb"}}>
              {["Symbol","Entry","Qty Left","Initial SL","Revised SL","Initial TOR","Unrealised P&L"].map(h=>(
                <th key={h} style={{padding:"8px 10px",textAlign:"left",fontSize:11,color:"#6b7280",fontWeight:600}}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {openTrades.map(trade=>{
                const exitedQty=(trade.exits||[]).reduce((s,e)=>s+e.exit_quantity,0);
                const remaining=trade.quantity-exitedQty;
                const currentPrice=trade.current_price||trade.entry_price;
                const unrealisedPnL=(currentPrice-trade.entry_price)*remaining;
                const initialTOR=(trade.entry_price-trade.initial_sl)*remaining;
                const rsl=revisedSL[trade.id];
                return (
                  <tr key={trade.id} style={{borderBottom:"1px solid #f3f4f6"}}>
                    <td style={{padding:"10px",fontWeight:700}}>{trade.symbol}</td>
                    <td style={{padding:"10px",fontFamily:"monospace"}}>{fmt(trade.entry_price)}</td>
                    <td style={{padding:"10px"}}>{remaining}</td>
                    <td style={{padding:"10px",fontFamily:"monospace",color:"#dc2626"}}>{fmt(trade.initial_sl)}</td>
                    <td style={{padding:"10px"}}>
                      <input type="number" placeholder={trade.initial_sl} value={rsl||""} onChange={e=>setRevisedSL(f=>({...f,[trade.id]:e.target.value}))}
                        style={{width:90,border:"1px solid #d1d5db",borderRadius:4,padding:"4px 6px",fontSize:12,fontFamily:"monospace"}} />
                    </td>
                    <td style={{padding:"10px",fontFamily:"monospace"}}>{fmt(initialTOR)}</td>
                    <td style={{padding:"10px",fontFamily:"monospace",fontWeight:700,color:unrealisedPnL>=0?"#16a34a":"#dc2626"}}>{fmt(unrealisedPnL)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      <div style={{marginTop:12,fontSize:11,color:"#9ca3af"}}>💡 Revised SL is for TOR recalculation only. Unrealised P&L uses entry price as proxy — update current price in Trades tab for accuracy.</div>
    </div>
  );
}
